import api from 'api'

export const updateDevolutive = async (id, payload) => {
  const { data } = await api.put(`/devolutive/${id}`, payload)

  return data
}
